import {useAxios} from "../helpers/useAxios";
import {AcceleratorContext} from "../context/acceleratorContext";
import {PropsWithChildren, useContext} from "react";
import {Accelerator} from "../interfaces/accelerator";
import React from 'react';

const URL = "/wp-json/pg/v2/sc/accelerators";

export const useAccelerator = () => useContext(AcceleratorContext);
export default function AcceleratorDataProvider({children}: PropsWithChildren<{}>) {
    const [loaded, accelerators, averageScore, setAverageScore, setAccelerators] = useAxios(URL);
    const value: {
        loaded: boolean,
        accelerators: Accelerator[],
        averageScore: number,
        setAverageScore: (value: number) => void,
        setAccelerators: ((value: (((prevState: Accelerator[]) => Accelerator[]) | Accelerator[])) => void)

    } = {
        loaded,
        accelerators,
        averageScore,
        setAverageScore,
        setAccelerators
    }
    return (
        <AcceleratorContext.Provider value={value}>
            {children}
        </AcceleratorContext.Provider>
    )
}